const READING_WPM = 200; // Average reading speed in words per minute

export interface Metadata {
    characterCount: number;
    wordCount: number;
    sentenceCount: number;
    readingTime: string;
    charFrequency: { [key: string]: number } | null;
}

export const calcMetadata = (input: string, excludeSpaces: boolean): Metadata => {
    const characterCount = excludeSpaces ? input.replace(/\s+/g, "").length : input.length;

    const wordCount = input.split(" ").filter((word) => word !== "").length;

    const sentenceCount = input
      .split(/[.!?]+/)
      .filter((sentence) => sentence.trim() !== "").length;

    const readingTimeMin = wordCount / READING_WPM;
    let readingTime;
    if (readingTimeMin < 1) {
      readingTime = `< 1 minute`;
    } else if (readingTimeMin >= 1 && readingTimeMin < 60) {
      readingTime = `~${Math.ceil(readingTimeMin)} minutes`;
    } else {
      const hours = Math.floor(readingTimeMin / 60);
      const minutes = Math.ceil(readingTimeMin % 60);
      readingTime = `${hours} hours ${minutes} minutes`;
    }

    const charFrequency: { [key: string]: number } = {};
    for (const char of input) {
      if (charFrequency[char]) {
        charFrequency[char]++;
      } else {
        charFrequency[char] = 1;
      }
    }
    const sortedCharFrequency = Object.entries(charFrequency).sort(
      (a, b) => b[1] - a[1]
    );



    return {
        characterCount,
        wordCount,
        sentenceCount,
        readingTime,
        charFrequency: Object.fromEntries(sortedCharFrequency),
    }
}